export default __webpack_public_path__ + "static/media/assign.3ab58288.svg";